"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VisualProof() {
  const {
    ref: introRef,
    isVisible: introVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const gridImages = [{
    src: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/545586104_864802186706358_8071547318210858067_n.jpg?v=dbvcvlva2ce",
    srcset: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/475129798_611974065322506_1051627063542971747_n.jpg?v=e3rdw2xakj-wvc-srcset",
    sizes: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/475129798_611974065322506_1051627063542971747_n.jpg?v=3gr7xcqaafw-wvc-sizes",
    alt: "Close-up of professional roof cleaning process removing moss",
    caption: "ROOF / RESTORATION",
    colSpan: "md:col-span-1",
    rowSpan: "row-span-2",
    aspect: "aspect-[3/5]"
  }, {
    src: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/6a9148ef-c555-4d2c-b091-26bd27097916.jpg?v=b5u2fky3bsd",
    srcset: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/6a9148ef-c555-4d2c-b091-26bd27097916.jpg?v=l0wolwnl1ig-wvc-srcset",
    sizes: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/6a9148ef-c555-4d2c-b091-26bd27097916.jpg?v=27ogzjidl6o-wvc-sizes",
    alt: "Pressure washing a dirty driveway surface",
    caption: "SURFACE / PRESSURE WASH",
    colSpan: "md:col-span-1",
    rowSpan: "row-span-1",
    aspect: "aspect-square"
  }, {
    src: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/475129798_611974065322506_1051627063542971747_n.jpg?v=ysbn9utl84t",
    srcset: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/475129798_611974065322506_1051627063542971747_n.jpg?v=vojll9o0nnh-wvc-srcset",
    sizes: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/475129798_611974065322506_1051627063542971747_n.jpg?v=b70ilh67fms-wvc-sizes",
    alt: "Commercial building roof maintenance in progress",
    caption: "COMMERCIAL / MAINTENANCE",
    colSpan: "md:col-span-2",
    rowSpan: "row-span-2",
    aspect: "aspect-[4/5]"
  }, {
    src: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/8f7bd8ce-49bb-4eab-9dc5-f2bbdbe76529.jpg?v=9ydwzuaj6ta",
    srcset: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/8f7bd8ce-49bb-4eab-9dc5-f2bbdbe76529.jpg?v=e6skibujciw-wvc-srcset",
    sizes: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/8f7bd8ce-49bb-4eab-9dc5-f2bbdbe76529.jpg?v=7jf8fkhaj4w-wvc-sizes",
    alt: "Professional inspection tools on a clean roof",
    caption: "INSPECTION / PRECISION",
    colSpan: "md:col-span-1",
    rowSpan: "row-span-1",
    aspect: "aspect-square"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/gutter_cleaning_before_after.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/gutter_cleaning_before_after.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/gutter_cleaning_before_after.png-wvc-sizes",
    alt: "Before and after gutter cleaning results",
    caption: "GUTTER / CLEARANCE",
    colSpan: "md:col-span-1",
    rowSpan: "row-span-2",
    aspect: "aspect-[3/5]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/roof_tile_restoration.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/roof_tile_restoration.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/roof_tile_restoration.png-wvc-sizes",
    alt: "Restored roof tiles showing clean finish",
    caption: "TILES / RESTORED",
    colSpan: "md:col-span-1",
    rowSpan: "row-span-1",
    aspect: "aspect-square"
  }, {
    src: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/480319923_634881999698379_8940498517400978967_n.jpg?v=lms5t0p0yn",
    srcset: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/480319923_634881999698379_8940498517400978967_n.jpg?v=6p4xprdhqvb-wvc-srcset",
    sizes: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/480319923_634881999698379_8940498517400978967_n.jpg?v=irpg9cayoq-wvc-sizes",
    alt: "Patio area being pressure washed",
    caption: "PATIO / CLEANING",
    colSpan: "md:col-span-1",
    rowSpan: "row-span-1",
    aspect: "aspect-square"
  }];
  const filmstrip = [{
    src: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/f26f7f4f-75a4-4d30-9e62-331178e71633.jpg?v=6opkb05gj5",
    srcset: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/f26f7f4f-75a4-4d30-9e62-331178e71633.jpg?v=1qwmmxkjscn-wvc-srcset",
    sizes: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/f26f7f4f-75a4-4d30-9e62-331178e71633.jpg?v=i082kpfur0g-wvc-sizes",
    caption: "Slate Cleaning",
    alt: "Roof inspection view"
  }, {
    src: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/efb18de0-c7af-43c5-ad64-40978dc7f6e8.jpg?v=kuq9m99wjhs",
    srcset: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/efb18de0-c7af-43c5-ad64-40978dc7f6e8.jpg?v=ka49l9prgls-wvc-srcset",
    sizes: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/efb18de0-c7af-43c5-ad64-40978dc7f6e8.jpg?v=7ntdb0n34oq-wvc-sizes",
    caption: "Moss Removal",
    alt: "Gutter debris removal"
  }, {
    src: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/cc961325-659f-4f29-b80f-a9772e62b606.jpg?v=68eo3gpwld",
    srcset: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/cc961325-659f-4f29-b80f-a9772e62b606.jpg?v=y8s3o68m1jj-wvc-srcset",
    sizes: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/cc961325-659f-4f29-b80f-a9772e62b606.jpg?v=fx3dyky3dbs-wvc-sizes",
    caption: "Roof Cleaning",
    alt: "Professional pressure washing equipment"
  }, {
    src: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/06e58548-1998-412b-aff6-2c568028b6ae.jpg?v=0ycoxk390qg",
    srcset: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/06e58548-1998-412b-aff6-2c568028b6ae.jpg?v=16j3rx4ht76-wvc-srcset",
    sizes: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/06e58548-1998-412b-aff6-2c568028b6ae.jpg?v=lqjxq6whb2-wvc-sizes",
    caption: "Roof Cleaning",
    alt: "Roof moss removal process"
  }, {
    src: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/593667653_980588045127771_2335141040494959264_n.jpg?v=cwgzduuvzb",
    srcset: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/593667653_980588045127771_2335141040494959264_n.jpg?v=hjvfsh7tpic-wvc-srcset",
    sizes: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/593667653_980588045127771_2335141040494959264_n.jpg?v=uyxtcrsidt-wvc-sizes",
    caption: "Commercial Gutter Clean",
    alt: "Gutter sealing repair"
  }, {
    src: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/559549102_908578818995361_3431574949486946791_n.jpg?v=q32kgmrf0e",
    srcset: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/559549102_908578818995361_3431574949486946791_n.jpg?v=pt1xsgiyme-wvc-srcset",
    sizes: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/559549102_908578818995361_3431574949486946791_n.jpg?v=yerqlmyhbom-wvc-sizes",
    caption: "Roof Clean",
    alt: "Commercial site cleaning"
  }, {
    src: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/525726040_804661016053809_2527760012309560975_n.jpg?v=f30s7hif9z5",
    srcset: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/525726040_804661016053809_2527760012309560975_n.jpg?v=sd8be5r5cwl-wvc-srcset",
    sizes: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/525726040_804661016053809_2527760012309560975_n.jpg?v=nnlavl2u1vl-wvc-sizes",
    caption: "Roof Clean",
    alt: "Roof safety equipment"
  }, {
    src: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/655752314_1133506903169217_6855077614386522589_n.jpg?v=awmwpt63ysj",
    srcset: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/655752314_1133506903169217_6855077614386522589_n.jpg?v=jd02wzopvu-wvc-srcset",
    sizes: "https://deciding-elf.10web.cloud/wp-content/uploads/2026/08/655752314_1133506903169217_6855077614386522589_n.jpg?v=asposj3wldk-wvc-sizes",
    caption: "Roof Clean",
    alt: "Final clean surface"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/roof_maintenance_check.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/roof_maintenance_check.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/roof_maintenance_check.png-wvc-sizes",
    caption: "CHECK / QUALITY",
    alt: "Quality check on roof"
  }];
  return <section data-section-id="2354" id="visual-proof-of-excellence" className="bg-background text-foreground w-full py-20 md:py-28 overflow-hidden">
      <div ref={introRef} className={`max-w-3xl mx-auto px-6 text-center transition-all duration-700 ease-out ${introVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="font-mono text-xs tracking-widest text-muted-foreground mb-6">
          [03] / OUR WORK
        </div>
        <h2 className="font-default text-4xl md:text-5xl lg:text-[48px] font-semibold tracking-tight leading-[1.05] text-foreground">
          Visual Proof of Excellence
        </h2>
        <p className="font-default mt-5 text-base md:text-lg text-muted-foreground max-w-xl mx-auto">See the difference. From deep roof restoration to precision gutter repairs, we bring industrial-grade care to every property.</p>
      </div>

      <div className="mt-14 md:mt-20 w-full px-3 md:px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-auto gap-3 md:gap-4">
          {gridImages.map((image, i) => <Link key={i} data-index={i} to="/" className={`group relative block overflow-hidden rounded-lg border border-border bg-card ${image.colSpan} ${image.rowSpan}`}>
              <div className={`relative w-full h-full ${image.aspect}`}>
                <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.03]" />
                <div className="absolute inset-0 bg-background/0 group-hover:bg-background/60 transition-colors duration-300" />
                <div className="absolute bottom-3 left-3 right-3 opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0 transition-all duration-300">
                  <span className="font-mono text-[11px] tracking-widest text-foreground bg-background/70 backdrop-blur-sm px-2 py-1 rounded-md border border-border">
                    {image.caption}
                  </span>
                </div>
              </div>
            </Link>)}

          <Link to="#" className="group relative col-span-2 md:col-span-2 row-span-1 aspect-[16/9] md:aspect-auto rounded-lg border border-border bg-primary text-primary-foreground overflow-hidden flex items-end p-6 md:p-8 transition-transform duration-300 hover:scale-[1.01]">
            <div className="absolute top-5 left-6 md:top-6 md:left-8 font-mono text-[11px] tracking-widest text-primary-foreground/70">
              [CTA] / REQUEST
            </div>
            <div className="flex items-end justify-between w-full gap-4">
              <div className="font-mono text-2xl md:text-3xl lg:text-4xl font-semibold leading-tight text-primary-foreground">
                GET A<br />FREE QUOTE
              </div>
              <ArrowRight className="size-8 md:size-10 text-primary-foreground transition-transform duration-300 group-hover:translate-x-1" />
            </div>
          </Link>
        </div>
      </div>

      <div className="mt-12 md:mt-16">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between mb-4">
          
          
        </div>

        <div className="w-full overflow-x-auto cursor-grab active:cursor-grabbing scrollbar-thin">
          <div className="flex gap-3 md:gap-4 px-3 md:px-4 pb-4 min-w-max">
            {filmstrip.map((item, i) => <div data-index={i} key={i} className="group relative w-[220px] md:w-[260px] shrink-0 rounded-lg overflow-hidden border border-border bg-card">
                <div className="relative aspect-[4/3] w-full">
                  <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.03]" />
                  <div className="absolute inset-0 bg-background/0 group-hover:bg-background/50 transition-colors duration-300" />
                </div>
                <div className="px-3 py-2.5 flex items-center justify-between">
                  <span className="font-mono text-[11px] tracking-widest text-muted-foreground">
                    {item.caption}
                  </span>
                  <span className="font-mono text-[11px] tracking-widest text-muted-foreground">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-6 mt-6 flex justify-center">
          <Button asChild variant="outline" size="lg" className="font-mono text-xs tracking-widest border-border bg-transparent text-foreground hover:bg-accent hover:text-accent-foreground">
            
          </Button>
        </div>
      </div>
    </section>;
}